import React from 'react';

import './footer.scss';

interface FooterProps {
}

const Footer: React.FC<FooterProps> = (props: FooterProps) => {
  return (
    <footer>
      <div className="container footer-bottom clearfix">
        <div className="links">
          <a href="#privacy-policy">Privacy Policy</a>
        </div>
        <div className="copyright">
          &copy; Copyright 2025 Bedican&reg; Ltd. Registered in England and Wales (No. 08704088).
        </div>
      </div>
    </footer>
  );
};

export default Footer;